module.exports = __webpack_public_path__ + "img/wave-bottom.a190843e.svg";